/** @file Reads one number from an array-like, mapping a missing slot to 0 (noUncheckedIndexedAccess). */

/** Returns a[i], or 0 when i is out of range. */
export function readNum(a: ArrayLike<number>, i: number): number {
  return a[i] ?? 0;
}
